<template>
  <el-dialog title="Please upload your files for the TPD Assist Booking" width="60%"
             :visible.sync="tpdFilesDialog"
             @close="cancelDialog">
    <div v-if="fileCountList[0] > 0" class="row d-flex align-items-center">
      <div class="box-col w-75">
        <b class="fs-16 required">Upload your blank MAS form X {{fileCountList[0]}} </b>
        <div class="fs-12">The form must be an editable version for the doctor to complete</div>
        <div class="d-flex">
          <div class="ml-2" v-for="(item, index) in fileList[0]" :key="index">
            <span class="d-flex justify-content-between align-center p-1" style="height: 20px; background: #e0e0e0">
               {{item.name}}
              <i @click="removeItem(0, index)" class="el-icon-close ml-2 cursor-pointer"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="box-col w-25">
        <v-btn @click="uploadFile(0)" small size="small" :disabled="fileCountList[0] === fileList[0].length" dark>Click here to upload</v-btn>
      </div>
    </div>
    <div v-if="fileCountList[1] > 0"  class="row mt-5 d-flex align-items-center">
      <div class="box-col w-75">
        <b class="fs-16 required">Upload your blank PIC form X {{fileCountList[1]}}</b>
        <div class="fs-12">The form must be an editable version for the doctor to complete</div>
        <div class="d-flex">
          <div class="ml-2"  v-for="(item, index) in fileList[1]" :key="index">
            <span class="d-flex justify-content-between align-center p-1" style="height: 20px; background: #e0e0e0">
               {{item.name}}
              <i @click="removeItem(1, index)" class="el-icon-close ml-2 cursor-pointer"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="box-col w-25">
        <v-btn :disabled="fileCountList[1] === fileList[1].length" @click="uploadFile(1)" small size="small" dark>Click here to upload</v-btn>
      </div>
    </div>
    <div v-if="fileCountList[2] > 0"  class="row mt-5 d-flex align-items-center">
      <div class="box-col w-75">
        <b class="fs-16 required">Upload your letter of instruction X {{fileCountList[2]}}</b>
        <div class="fs-12"></div>
        <div class="d-flex">
          <div class="ml-2"  v-for="(item, index) in fileList[2]" :key="index">
            <span class="d-flex justify-content-between align-center p-1" style="height: 20px; background: #e0e0e0">
               {{item.name}}
              <i @click="removeItem(2, index)" class="el-icon-close ml-2 cursor-pointer"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="box-col w-25">
        <v-btn :disabled="fileCountList[2] === fileList[2].length" @click="uploadFile(2)" small size="small" dark>Click here to upload</v-btn>
      </div>
    </div>
    <div v-if="fileCountList[3] > 0"  class="row mt-5 d-flex align-items-center">
      <div class="box-col w-75">
        <b class="fs-16 required">Upload your support brief material X {{fileCountList[3]}}</b>
        <div class="fs-12"></div>
        <div class="d-flex">
          <div class="ml-2"  v-for="(item, index) in fileList[3]" :key="index">
            <span class="d-flex justify-content-between align-center p-1" style="height: 20px; background: #e0e0e0">
               {{item.name}}
              <i @click="removeItem(3, index)" class="el-icon-close ml-2 cursor-pointer"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="box-col w-25">
        <v-btn :disabled="fileCountList[3] === fileList[3].length" @click="uploadFile(3)" small size="small" dark>Click here to upload</v-btn>
      </div>
    </div>
    <input
        type="file"
        class="w-px h-px opacity-0 overflow-hidden absolute"
        @change="onChange"
        ref="files"
        id="assetsFieldHandle1"
        accept=".pdf,.jpg,.jpeg,.png,.docx,.xlsx,.txt,.gif,.ds2" />
    <label for="assetsFieldHandle1"></label>
    <div slot="footer" class="dialog-footer">
    <v-btn dark class="white-button" @click="cancelDialog">Cancel</v-btn>
    <el-button type="primary" @click="next">OK</el-button>
  </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'TPDFiles',
  props: ['tpdFilesDialog', 'fileCountList', 'client'],
  data() {
    return {
      curIndex: 0,
      fileList: [[], [], [], []],
      fileNames: [],
    }
  },
  methods: {
    uploadFile(index) {
      this.curIndex = index
      $('#assetsFieldHandle1').trigger('click')
    },
    cancelDialog() {
      this.fileList = [[], [], [], []]
      this.fileNames = []
      this.$emit('cancelDialog')
    },
    next() {
      this.$emit('next', this.fileList)
      this.fileList = [[], [], [], []]
      this.fileNames = []
    },
    removeItem(index, i) {
      const item = this.fileList[index][i].name
      const p = this.fileNames.findIndex(it => it === item)
      if(p > -1) {
        this.fileNames.splice(p, 1)
      }
      this.fileList[index].splice(i, 1)
      this.$forceUpdate()
    },
    onChange(e) {
      if (e.target.files && !this.fileNames.includes(e.target.files[0].name)) {
        if(!this.fileList[this.curIndex]) {
          this.fileList[this.curIndex] = []
        }
        this.fileList[this.curIndex].push(e.target.files[0])
        this.fileNames.push(e.target.files[0].name)
      } else if(this.fileNames.includes(e.target.files[0].name)) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-error">' +
              '            <b>Error:</b> You have already upload this file!' +
              '          </div>',
        });
      }
      this.$forceUpdate()
      this.$refs.files.type = ''
      setTimeout(() => {
        this.$refs.files.type = 'file'
      }, 100)
    }
  }
}
</script>
